const SodenarListConfig = [
  {
    href: "/profile",
    title: "Profile",
  }, {
    href: "/settings/verify",
    title: "Verify",
  }, {
    href: "/settings/balance",
    title: "Balance",
  }, {
    href: "/settings/withdraw",
    title: "Withdraw",
  },
]

export { SodenarListConfig };